module.exports = require('../internals/shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/function-to-string.js
// module id = 110
// module chunks = 0